import { AxiosError } from 'axios'
import {
  type QueryFunctionContext,
  useQuery,
  type UseQueryOptions
} from 'react-query'

import useAuth from 'hooks/use-auth'
import { fetchQueryData } from 'hooks/use-gremlin-query'
import { getEndpointWithParams } from 'queries/queries-utils'
import { testSuitesQueryKeys } from 'queries/test-suites/query-keys'
import { type TestSuite } from 'types/api/test-suites/test-suites'

export function fetchTestSuite({
  queryKey: [baseUrl, params]
}: QueryFunctionContext<ReturnType<typeof testSuitesQueryKeys.testSuite>>) {
  if (!baseUrl) {
    throw new AxiosError('query did not provide a valid test suite id')
  }

  if (!params.teamId) {
    throw new AxiosError('query did not provide a teamId')
  }

  const endpointWithParams = getEndpointWithParams(baseUrl, params)
  return fetchQueryData(endpointWithParams, {})
}

export function useGetTestSuite(
  testSuiteId: string | undefined,
  queryOptions?: Omit<
    UseQueryOptions<TestSuite, AxiosError>,
    'queryKey' | 'queryFn'
  >
) {
  const { currentTeamId } = useAuth()

  return useQuery({
    ...queryOptions,
    queryFn: fetchTestSuite,
    ...(testSuiteId && {
      queryKey: testSuitesQueryKeys.testSuite(testSuiteId, {
        teamId: currentTeamId
      })
    })
  })
}
